import { NAME_SPACE } from './config';
import cardCarousel from './CardCarousel.vue';

export default {
    name: NAME_SPACE,
    components: {
        'card-carousel': cardCarousel,
    },
};
